import { NextResponse } from 'next/server'
import { and, eq } from 'drizzle-orm'
import { auth } from '@/auth'
import { db } from '@/db'
import { tenantMemberships, tenants } from '@/db/schema'

export async function GET() {
  const session = await auth()
  if (!session?.user?.id) {
    return NextResponse.json({ error: 'Unauthorized' }, { status: 401 })
  }

  const rows = await db
    .select({
      tenantId: tenantMemberships.tenantId,
      tenantName: tenants.name,
      role: tenantMemberships.role,
    })
    .from(tenantMemberships)
    .innerJoin(tenants, eq(tenants.id, tenantMemberships.tenantId))
    .where(
      and(
        eq(tenantMemberships.userId, session.user.id),
        eq(tenantMemberships.isActive, true),
      )
    )

  const result = rows.map((r) => ({
    tenantId: r.tenantId,
    tenantName: r.tenantName,
    role: r.role,
    isCurrent: r.tenantId === session.user.tenantId,
  }))

  return NextResponse.json(result)
}
